<app-header></app-header>

<div class="ethics">
  <div class="ethics_top text-center">
    <ng-container *ngFor="let heading of head">
      <div
        class="bg_6 inline_padding2 ethics_top_box"
        *ngIf="heading.page === currentPage"
      >
        <div class="ethics_top_box_inner">
          <div class="inline_padding3">
            <span class="text_style_5">Code of Ethics</span>
          </div>
          <div class="inline_padding3 p-top-16">
            <span
              class="text_style_1"
              [innerHtml]="heading.page_sub_heading"
            ></span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="inline_padding1 ethics_bottom">
    <div class="ethics_bottom_body">
      <div class="border_right_blue">
        <ng-container *ngFor="let ethics of data; let i = index">
          <div
            class="edit_body_heading width-100-per"
            (click)="toggledescription(i)"
            [ngClass]="{ 'right-border-3': highlightedIndex === i }"
            [id]="'item-' + i"
          >
            <div class="width-100-per">
              <div class="cursor-pointer m-r-3-neg m-r-3-neg">
                <div class="p-y-18">
                  <span
                    id="title-{{ i }}"
                    [innerHtml]="ethics.title"
                    [ngClass]="{
                      text_blue_16: highlightedIndex === i,
                      text_black_14: highlightedIndex !== i
                    }"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="ethics_bottom_body_description">
        <ng-container *ngFor="let ethics of data; let i = index">
          <div
            class="p-x-30 p-y-40"
            [ngClass]="{ bottom_border_trans_5: i !== data.length - 1 }"
          >
            <div
              class="right text_style_9 text_align-justify"
              [id]="'description-' + i"
              [innerHtml]="ethics.description"
            ></div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
<!-- <ng-container *ngFor="let ethics of data; let i = index">
    <div class="right-border-1 dis-flex-2">
        <div class="edit_body_heading width-100-per" (click)="toggledescription(i)"
            [ngClass]="{ 'right-border-3': highlightedIndex === i }" [id]="'item-' + i">
            <div class="width-100-per">
                <div class="cursor-pointer m-r-3-neg p-x-20">
                    <div class="p-y-18">
                        <span id="title-{{i}}" [innerHtml]="ethics.title" [ngClass]="{
                            'text_blue_16': highlightedIndex === i,
                            'text_black_14': highlightedIndex !== i
                        }"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-x-30 p-y-40 ethics_bottom_scrollable-description" [ngClass]="{ 'bottom_border_trans_5': i !== data.length - 1 }">
        <div class="right text_style_9 text_align-justify" [id]="'description-' + i" [innerHtml]="ethics.description"></div>
    </div>
</ng-container> -->
